import { createContext } from "react";

const TicketScreen = createContext<any>(null);

export default TicketScreen;
